export const AnnouncementKind = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error',
    Success: 'Success'
} as const;

export type AnnouncementKind = typeof AnnouncementKind[keyof typeof AnnouncementKind];
